import type {SpecificallyAuditDataItemValues} from './SpecificallyAuditDataItemValues';

export type SpecificallyAuditDataItem = {
  vehicleId: string;
  lastUpdate: string;
  values: Array<SpecificallyAuditDataItemValues>;
};
